<template>
  <teleport
    :to="mountTo"
    :class="$props.class"
    :style="style"
  >
    <div
      :style="wrapperStyle"
      :class="wrapperClass"
    >
      <div
        v-bind="$attrs"
        ref="content"
        :class="contentClass"
        :style="contentStyle"
      >
        <template v-if="show">
          <slot />
        </template>
      </div>
    </div>
  </teleport>
</template>

<script>
import { floatingRootKey } from '@/shared/legacy/ui/floating-root';
import { mountPoint } from './mount-point';

let zIndex = 1050;

export default {
  name: 'LayerPortal',
  inject: {
    floatingRoot: {
      from: floatingRootKey,
      default: undefined
    }
  },
  inheritAttrs: false,
  props: {
    wrapperClass: {
      type: [String, Array, Object],
      default: ''
    },
    contentClass: {
      type: [String, Array, Object],
      default: ''
    },
    contentStyle: {
      type: [String, Object],
      default: ''
    },
    zIndexIncrement: {
      type: Number,
      default: 1
    },
    class: {
      type: [String, Array, Object],
      default: undefined
    },
    style: {
      type: [String, Array, Object],
      default: undefined
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    teleportTarget() {
      const root = this.floatingRoot?.value ?? this.floatingRoot;

      return root || undefined;
    },
    mountTo() {
      return this.teleportTarget ?? `#${mountPoint.id}`;
    },
    wrapperStyle() {
      return {
        zIndex: this.teleportTarget ? 'auto' : zIndex,
        position: 'relative'
      };
    }
  },
  beforeMount() {
    if (!this.teleportTarget) {
      zIndex += this.zIndexIncrement;
      mountPoint.create(this.$style.container);
    }
  },
  mounted() {
    // фиксим поведение с прыгающим экраном при автофокусе при монтировании компонента, получается сначала позиционируем обёртку, а потом уже монтируем контент
    // пример https://huntflow.atlassian.net/browse/DEV-11350
    this.show = true;
  },
  beforeUnmount() {
    if (!this.teleportTarget) {
      zIndex -= this.zIndexIncrement;
    }
  },
  methods: {
    getContent() {
      return this.$refs.content;
    }
  }
};
</script>

<style module>
.container {
  position: absolute;
  top: 0;

  @media print {
    position: static;
  }
}
</style>

<i18n lang="json">{}</i18n>
